import { usePerfectGiftBoxContext } from '@/src/common/contexts/PerfectGiftBoxContext'
import {
    DenomBox,
    DenomBoxWrapper,
    HeaderParagraphText,
} from '@/src/modules/build-a-card/StyledComponents'
import { TextInputWithLabel } from '@/src/common/components/elements/Forms/TextInputWithLabel'
import { KYC_MAX_CARDS, minCardsBox } from '@/src/modules/checkout/strings'
import { BaseSyntheticEvent } from 'react'
import { FormErrorDisplay } from '@/src/modules/build-a-card/FormErrorDisplay'
import RequiredAsterisk from '@/src/common/components/elements/Forms/RequiredAsterisk'
import { validateCardQuantity } from '@/src/modules/build-a-card/validations/validateCardQuantity'
import { FieldWrapper } from '@/src/common/components/elements/Forms/StyledComponents'

const PerfectGiftBoxQuantitySelectorButtons = () => {
    const { cardQuantity, setCardQuantity, formErrors, setFormErrors } =
        usePerfectGiftBoxContext()
    const defaultQuantities = [5, 10, 15, 20, 25, 50]

    return (
        <FieldWrapper>
            <HeaderParagraphText>
                First, choose how many cards you want:
                <RequiredAsterisk />
            </HeaderParagraphText>
            <DenomBoxWrapper>
                {defaultQuantities.map((quantity) => {
                    return (
                        <DenomBox
                            key={`${quantity}-button`}
                            id={`${quantity}-button`}
                            label={`${quantity}`}
                            onClick={() =>
                                validateCardQuantity(
                                    quantity,
                                    setCardQuantity,
                                    formErrors,
                                    setFormErrors,
                                    minCardsBox,
                                    KYC_MAX_CARDS
                                )
                            }
                            variant={
                                cardQuantity == quantity
                                    ? 'graySquareButtonActive'
                                    : 'graySquareButton'
                            }
                            type={'button'}
                        />
                    )
                })}
            </DenomBoxWrapper>
            <TextInputWithLabel
                name={'cardQuantity'}
                type={'number'}
                data-testid={'cardQuantity'}
                placeholder={`Enter an amount of cards from ${minCardsBox} to ${KYC_MAX_CARDS}`}
                value={!!cardQuantity ? cardQuantity : ''}
                min={minCardsBox}
                max={KYC_MAX_CARDS}
                onChange={(e: BaseSyntheticEvent) => {
                    const quantity: number = e?.target?.value || 0
                    validateCardQuantity(
                        quantity,
                        setCardQuantity,
                        formErrors,
                        setFormErrors,
                        minCardsBox,
                        KYC_MAX_CARDS
                    )
                }}
            />
            <FormErrorDisplay formErrors={formErrors} path={'cardQuantity'} />
        </FieldWrapper>
    )
}

export default PerfectGiftBoxQuantitySelectorButtons
